@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

// Variants

.wizard {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--dark-4);
  --chip-border-color: transparent;
  --chip-front-icon-color: var(--dark-40);

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-8);
  --chip-border-color-hover: var(--chip-border-color);
  --chip-front-icon-color-hover: var(--chip-front-icon-color);

  --chip-color-active: var(--selected-fill);
  --chip-background-color-active: var(--default-bg);
  --chip-border-color-active: color-mix(in srgb, var(--selected-fill) 20%, transparent);
  --chip-front-icon-color-active: var(--selected-fill);

  &.xs {
    @include xs-medium;
  }

  &.sm {
    @include sm-medium;
  }

  &.md {
    @include md-medium;

    [data-autopilot-system-redesign='on'] & {
      @include sm-sohne;
    }

    svg {
      margin-top: 1px;
    }
  }

  &.withFrontIcon {
    padding-left: 8px;
  }

  &.xl {
    @include md-sohne-medium;
  }
}

.catalogue {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--dark-4);
  --chip-border-color: transparent;

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-8);
  --chip-border-color-hover: var(--chip-border-color);

  --chip-color-active: var(--light-100);
  --chip-background-color-active: var(--selected-fill);
  --chip-border-color-active: var(--chip-border-color);

  &.xs {
    @include xs-medium;
  }

  &.sm {
    @include sm-medium;
  }

  &.md {
    @include md-medium;

    [data-autopilot-system-redesign='on'] & {
      @include sm-sohne;
    }
  }

  &.lg {
    @include lg-medium;
  }

  &.xl {
    @include md-sohne-medium;
  }
}

.wizardsV3 {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--dark-4);
  --chip-border-color: transparent;
  --chip-front-icon-color: transparent;

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-8);
  --chip-border-color-hover: var(--chip-border-color);

  --chip-color-active: var(--light-100);
  --chip-background-color-active: var(--selected-fill);
  --chip-border-color-active: var(--chip-border-color);

  &.xs {
    @include xs-medium;
  }

  &.sm {
    @include sm-medium;
  }

  &.md {
    @include md-medium;

    [data-autopilot-system-redesign='on'] & {
      @include sm-sohne;
    }
  }

  &.lg {
    @include lg-medium;
  }

  &.xl {
    @include md-sohne-medium;
  }

  .icon {
    width: 24px;
    height: 24px;
  }
}

.flat {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--dark-3);
  --chip-border-color: transparent;
  --chip-front-icon-color: var(--dark-80);

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-8);
  --chip-border-color-hover: transparent;

  --chip-color-active: var(--light-100);
  --chip-background-color-active: var(--selected-fill);
  --chip-border-color-active: transparent;

  .icon {
    width: 20px;
    height: 20px;
  }

  &.xs {
    @include xs-sohne-book;
    height: 22px;
  }

  &.sm {
    @include sm-sohne;
    height: 24px;
  }

  &.md {
    @include sm-sohne;
    height: 33px;
  }

  &.lg {
    @include md-sohne;
    height: 45px;

    .icon {
      width: 30px;
      height: 30px;
    }
  }

  &.xl {
    @include md-sohne-medium;
    height: 40px;
    padding: 0 14px;
    gap: 4px;

    .icon {
      width: 24px;
      height: 24px;
    }
  }

  &.xxl {
    @include md-sohne-medium;
    height: 40px;
    padding: 8px 14px;
    gap: 4px;

    .icon {
      width: 24px;
      height: 24px;
    }
  }
}

.square {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--dark-3);
  --chip-border-color: var(--dark-4);
  --chip-front-icon-color: var(--dark-80);

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-8);
  --chip-border-color-hover: var(--dark-4);

  --chip-color-active: var(--light-100);
  --chip-background-color-active: var(--selected-fill);
  --chip-border-color-active: var(--dark-4);

  .icon {
    width: 20px;
    height: 20px;
  }

  &.xs {
    @include xs-sohne-book;
    height: 22px;
  }

  &.sm {
    @include sm-sohne;
    height: 24px;
  }

  &.md {
    @include sm-sohne;
    height: 33px;
  }

  &.lg {
    @include md-sohne;
    height: 45px;

    .icon {
      width: 30px;
      height: 30px;
    }
  }

  &.xl {
    @include md-sohne-medium;
    height: 40px;
    padding: 0 14px;
    gap: 4px;

    .icon {
      width: 24px;
      height: 24px;
    }
  }

  &.xxl {
    @include md-sohne-medium;
    height: 40px;
    padding: 8px 14px;
    gap: 4px;

    .icon {
      width: 24px;
      height: 24px;
    }
  }
}

.button {
  --chip-color: var(--selected-fill);
  --chip-background-color: var(--selected-fill-10);
  --chip-border-color: transparent;
  --chip-front-icon-color: var(--selected-fill);

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--selected-fill-10);
  --chip-border-color-hover: transparent;

  --chip-color-active: var(--chip-color);
  --chip-background-color-active: var(--selected-fill-10);
  --chip-border-color-active: transparent;
}

.filter {
  --chip-color: var(--dark-80);
  --chip-background-color: var(--light-100);
  --chip-border-color: var(--dark-8);
  --chip-front-icon-color: var(--dark-40);

  --chip-color-hover: var(--chip-color);
  --chip-background-color-hover: var(--dark-4);
  --chip-border-color-hover: var(--chip-border-color);
  --chip-front-icon-color-hover: var(--chip-front-icon-color);

  --chip-color-active: var(--selected-fill);
  --chip-background-color-active: var(--overlay);
  --chip-border-color-active: var(--selected-fill);
  --chip-front-icon-color-active: var(--selected-fill);

  &.sm {
    @include sm-regular;
  }

  &.md {
    @include md-regular;
  }

  &.withFrontIcon {
    padding-left: 10px;
  }
}

// Base styles
.chip {
  padding: 6px 9px;
  background-color: var(--chip-background-color);
  box-shadow: inset 0 0 0 1px var(--chip-border-color);

  display: inline-flex;
  align-items: center;
  column-gap: 4px;
  border-radius: 32px;

  @include transition;
  @include line-clamp;
  color: var(--chip-color);
  -webkit-tap-highlight-color: transparent;

  &:hover:not(.disabled):not(.selected) {
    background: var(--chip-background-color-hover);
  }

  svg {
    fill: var(--chip-front-icon-color);
  }

  &.catalogue {
    padding: 6px 16px;
    min-width: max-content;
  }

  &.wizardsV3 {
    padding: 5px 12px 5px 5px;
    min-width: max-content;
  }

  &.square {
    border-radius: 8px;
  }

  &.xs {
    height: 22px;
  }

  &.sm {
    height: 24px;
  }

  &.md {
    height: 32px;
  }

  &.lg {
    height: 36px;

    &.number {
      padding: 6px 14px;
    }
  }

  &.button {
    .icon {
      width: 20px;
      height: 20px;
    }
  }

  [data-autopilot-system-redesign='on'] & {
    border-radius: 10px;
    border: 1px solid var(--dark-4);
    background: var(--dark-3);

    &.xxl {
      height: 44px;
      gap: 8px;
      padding: 10px 12px;
      font-weight: 400;
      line-height: 130%;
      letter-spacing: 0.18px;

      .icon {
        width: 24px;
        height: 24px;

        svg {
          width: 24px !important;
          height: 24px !important;
        }
      }
    }
  }
}

.withAvatar {
  padding-left: 6px;
}

.disabled {
  opacity: 0.4;
}

.focus {
  background: var(--chip-background-color-hover);
  box-shadow: inset 0 0 0 2px rgba(var(--chip-background-color-hover), 0.1);
}

.selected {
  box-shadow: inset 0 0 0 1px var(--chip-border-color-active);
  background: var(--chip-background-color-active);
  color: var(--chip-color-active);

  .icon {
    color: var(--chip-front-icon-color-active);
  }

  [data-autopilot-system-redesign='on'] & {
    background: var(--light-100);
    color: var(--dark-80);
    border: 1px solid var(--dark-80);
    box-shadow: none;
    font-weight: 500 !important;
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--chip-front-icon-color);
}

.delete {
  display: flex;
  height: 20px;
  width: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  svg path {
    stroke-width: 2.5;
  }
}
